module.exports = __webpack_public_path__ + "static/media/delete.03637c79.svg";